import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';
import { JSX } from 'react/jsx-runtime';

const ArrowUpLeft = (
  props: JSX.IntrinsicAttributes &
    Omit<
      React.SVGProps<SVGSVGElement>,
      'as' | 'translate' | keyof IconProps
    > & { htmlTranslate?: 'yes' | 'no' | undefined } & IconProps & {
      as?: 'svg' | undefined;
    }
) => {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width='18px'
      height='18px'
      viewBox='0 0 24 24'
      fill='none'
      stroke='#16a34a'
      strokeWidth='3'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <line x1='17' y1='7' x2='7' y2='17'></line>
      <polyline points='17 17 7 17 7 7'></polyline>
    </Icon>
  );
};

export default ArrowUpLeft;
